const Opinion = () => {
  return (
    <div className="round-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
        <g>
          <path d="M61.71,80.83q.4,0,.81,0H77.87a0,0,0,0,1,0,0Z" />
          <path d="M117.85,40.39a3.26,3.26,0,1,1-3.26-3.26A3.26,3.26,0,0,1,117.85,40.39Z" />
          <path d="M104.87,40.39a3.26,3.26,0,1,1-3.25-3.26A3.26,3.26,0,0,1,104.87,40.39Z" />
          <path d="M92,40.39a3.25,3.25,0,1,1-3.25-3.26A3.25,3.25,0,0,1,92,40.39Z" />
          <g>
            <path d="M78.1,73.43v0h3.71v0Z" />
            <path d="M140.74,91.58a25.7,25.7,0,0,1-7.23-10.72h4.25a11.34,11.34,0,0,0,11.33-11.33V11.36A11.34,11.34,0,0,0,137.76,0H62.52A11.34,11.34,0,0,0,51.19,11.36V52.54H39.47L33.65,20.35V8.17h-20V20.32L5.13,67.39C3.9,69.47.39,76,.15,83c-.24,7.41,0,56.39,0,58.47l0,.32a9,9,0,0,0,9.12,8.27H75.93l-.4-4.06c0-.25-2.28-24.39,3.87-41.66,4.15-11.63,5.51-19.24,5.94-23.51h25c4.28,5.31,14.93,16.68,27.91,17.33l11.68.59ZM51.19,59.94v9.59a11.23,11.23,0,0,0,.69,3.9H30.54V59.94ZM33.34,142.69H9.29a1.54,1.54,0,0,1-1.74-1.45c0-3.69-.24-50.94,0-58,.21-6.27,4.17-12.48,4.2-12.53l.41-.63L21,21.31,21,21V15.57h5.21V21L32,52.54h-8.8V76.83c-.08,1.53-.17,9.92,6.1,27.54C34,117.82,33.73,135.44,33.34,142.69Zm39.09-40.8c-5.19,14.57-5,32.79-4.55,40.8H40.77a138.88,138.88,0,0,0-1-25.35,78.51,78.51,0,0,0-3.6-15.45c-3.7-10.39-5-17.27-5.45-21.06H77.88a0,0,0,0,0,0,0C77.42,84.66,76.12,91.53,72.43,101.89Zm42.7-27L114,73.46H62.52a3.44,3.44,0,0,1-.46,0,3.94,3.94,0,0,1-3.47-3.9V11.36a3.93,3.93,0,0,1,3.93-3.93h75.24a3.93,3.93,0,0,1,3.93,3.93V69.53a3.93,3.93,0,0,1-3.93,3.93H124.25l.8,4.36a33.82,33.82,0,0,0,3.18,9.39A52.36,52.36,0,0,1,115.13,74.93Z" />
          </g>
          <path d="M81.81,73.43v0H62.52a3.44,3.44,0,0,1-.46,0Z" />
        </g>
      </svg>
    </div>
  );
};

export default Opinion;
